// @flow
import React from 'react';
import { TreeSelect } from 'antd';
import notification from 'antd/lib/notification';

import type { OrgUnitNode } from './../lib/types/';
import { orgUnitApi } from '../lib/api';

type OrgUnitFilter = {
  nodeId?: number,
  nodeFilterType?: NodeFilterType,
  onlyBranch?: boolean,
  onlyService?: boolean,
  accessType: string
};

type Props = {
  value?: Array<any>, // массив выбранных ID
  onChange?: (values: Array<any>) => void,
  filter?: OrgUnitFilter,
  onlyBranches?: boolean,
  showAllBranchesOption?: boolean,
  allBranchesOptionValue?: any,
  hideMainBranch?: boolean,
  isFilter?: boolean,
  placeholder?: string,
  allowClear?: boolean,
  // любые другие пропсы, которые принимает TreeSelect
  [key: string]: any
};

type State = {
  tree: ?OrgUnitNode
};

export default class OrgUnitMultiSelect extends React.Component<Props, State> {
                 static defaultProps = {
                   onlyBranches: false,
                   placeholder: 'Выберите филиалы',
                   allowClear: true
                 };

                 state = {
                   tree: null
                 };

                 _isMounted = false;
                 _nodeById: { [key: string]: OrgUnitNode } = {};

                 mapData = (node: OrgUnitNode) => ({
                   ...node,
                   value: node.id,
                   title: node.name,
                   children: node.children
                     ? node.children
                         .filter(child =>
                           this.props.onlyBranches
                             ? child.type === 'branch'
                             : true
                         )
                         .map(child => this.mapData(child))
                     : []
                 });

                 indexTree = (node: any) => {
                   if (!node) {
                     return;
                   }

                   // "Все филиалы" synthetic wrapper doesn't have a real id
                   if (node.id != null) {
                     this._nodeById[String(node.id)] = node;
                   }

                   if (node.children && node.children.length) {
                     node.children.forEach(child => this.indexTree(child));
                   }
                 };

                 async componentDidMount() {
                   this._isMounted = true;
                   try {
                     const tree = this.mapData(
                       await orgUnitApi.fetchOrgUnits({
                         ...this.props.filter,
                         returnDeleted: this.props.isFilter ? true : undefined
                       })
                     );
                     if (this._isMounted) {
                       if (this.props.showAllBranchesOption) {
                         this.setState({
                           tree: {
                             children: this.props.hideMainBranch
                               ? tree.children
                               : [tree],
                             value: this.props.allBranchesOptionValue || null,
                             title: 'Все филиалы',
                             key: 0
                           }
                         });
                       } else {
                         this.setState({ tree });
                       }
                     }
                     this._nodeById = {};
                     this.indexTree(this.state.tree);
                   } catch (error) {
                     notification.error({
                       message: 'Ошибка загрузки филиалов',
                       description: error.message
                     });
                   }
                 }

                 componentWillUnmount() {
                   this._isMounted = false;
                 }

                 collectDescendantIds = (node: OrgUnitNode): Array<number> => {
                   const result: Array<number> = [];
                   if (!node.children || node.children.length === 0) {
                     return result;
                   }

                   node.children.forEach(child => {
                     result.push(child.id);
                     result.push(...this.collectDescendantIds(child));
                   });
                   return result;
                 };

                 normalizeSelectedIds = (values: Array<any>): Array<any> => {
                   if (!values || values.length === 0) {
                     return [];
                   }

                   const out = new Set();
                   values.forEach(id => {
                     const node = this._nodeById[String(id)];
                     if (node && node.children && node.children.length) {
                       // Parent selected: send only lower nodes (all descendants)
                       this.collectDescendantIds(node).forEach(descId =>
                         out.add(descId)
                       );
                       out.add(id);
                     } else {
                       // Leaf selected: send the leaf id
                       out.add(id);
                     }
                   });

                   return Array.from(out);
                 };

                 handleChange = (values: Array<any>) => {
                   const { onChange } = this.props;
                   if (!onChange) {
                     return;
                   }

                   onChange(this.normalizeSelectedIds(values));
                 };

                 render() {
                   const { tree } = this.state;
                   const { value, onChange, ...restProps } = this.props;

                   return (
                     <TreeSelect
                       multiple
                       treeCheckable
                       treeSelectable={false}
                       treeDefaultExpandAll={false}
                       showSearch
                       showCheckedStrategy={TreeSelect.SHOW_PARENT}
                       treeNodeFilterProp="title"
                       treeData={tree ? [tree] : []}
                       value={value || []}
                       onChange={this.handleChange}
                       {...restProps}
                     />
                   );
                 }
               }
